import React from 'react';

export const pageMeta = {
  "name": "JSON Arrays",
  "link": "/javascript/json/arrays"
};

export default function JavascriptJsonArrays() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JSON Arrays</h2>
      <p>Route: /javascript/json/arrays</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
